import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './assets/logo.png';
import { toast } from 'react-toastify';

const Login = () => {
  const navigate = useNavigate();

  const [members, setMembers] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = {
      members: members.trim(),
      email: email.trim(),
      password: password.trim(),
    };
    const validationErrors = [];
    if (!body.members) {
      validationErrors.push('Numele nu este completat!');
    } else if (!/^[a-zA-Z0-9]+$/.test(body.members)) {
      validationErrors.push('Numele nu este valid!');
    }
    if (!body.email) {
      validationErrors.push('Email-ul nu este completat!');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(body.email)) {
      validationErrors.push('Email-ul nu este valid!');
    }
    if (!body.password) validationErrors.push('Parola nu este completata!');
    if (validationErrors.length) {
      toast.error(({ closeToast }) => (
        <>
          {validationErrors.map((error, index) => (
            <div key={index}>{error}</div>
          ))}
        </>
      ));
      return;
    }
    try {
      const res = await fetch('https://api.dcsoft.ro/ext/api/users/login', {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' },
      });
      if (!res.ok) {
        throw new Error(
          `Error logging user: ${res.status} - ${res.statusText}`
        );
      }
      const data = await res.json();
      localStorage.setItem(
        'user',
        JSON.stringify({
          trackerId: data._id,
          members: data.members,
          isGroup: data.isGroup,
        })
      );
      toast.success('Autentificare reusita!');
      navigate('/dashboard');
    } catch (error) {
      toast.error('Eroare autentificare!');
      console.log(error.message);
    }
  };

  return (
    <section className="login">
      <div className="container1 login">
        <h1>
          <span>CASH</span>
          <span>FL</span>
          <img src={logo} alt="" style={{ height: 36, width: 36 }} />
          <span>W</span>
        </h1>
        <div className="line"></div>
        <p>
          Bugetul personal este secretul libertatii financiare. Fii liber
          incepand de azi!
        </p>
        <form noValidate onSubmit={handleSubmit}>
          <div className="form-control">
            <label>Nume</label>
            <input
              type="text"
              placeholder="Nume..."
              value={members}
              onChange={(e) => setMembers(e.target.value)}
            />
          </div>
          <div className="form-control">
            <label>Email</label>
            <input
              type="text"
              inputMode="email"
              placeholder="Email..."
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-control">
            <label>Parola</label>
            <input
              type="password"
              placeholder="Parola..."
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <input
            type="submit"
            className="btn login-btn"
            value="Autentificare"
          />
        </form>
      </div>
    </section>
  );
};

export default Login;
